package com.anjuros.website.redesign.sections.blogarticle

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.anjuros.website.components.changeMode
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.components.setMeta
import com.anjuros.website.redesign.components.RdScrollReveal
import com.anjuros.website.redesign.components.SiteFooter
import com.anjuros.website.redesign.components.SiteHeader
import com.anjuros.website.redesign.components.rdNavItems
import com.anjuros.website.redesign.components.setJsonLd
import com.anjuros.website.redesign.sections.blog.BlogGuides
import com.anjuros.website.redesign.styles.RdPageStyle
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.SITE_URL
import com.anjuros.website.templates.selection.modules.BlogCard
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Main

/** The page of one blog article; every article page uses it with its own [BlogCard]. */
@Composable
fun BlogArticlePage(card: BlogCard) {
    val guide = BlogGuides.first { it.card == card }
    val title = LocalText(guide.metaTitle)
    val description = LocalText(guide.metaDescription)
    val structuredData = articleStructuredData(guide)

    LaunchedEffect(card) {
        setMeta(title, description, image = "$SITE_URL${guide.image.src}", url = "$SITE_URL${card.pathToArticle}")
        setJsonLd("ld-article", structuredData)
        changeMode(UiMode.NORMAL)
    }

    Div(RdPageStyle.toModifier().toAttrs()) {
        SiteHeader(rdNavItems(currentPath = RdRoute.BLOG))
        Main {
            ArticleHeadSection(guide)
            ArticleBodySection(guide)
            ArticleMoreSection(guide)
        }
        SiteFooter()
        RdScrollReveal()
    }
}
